import React, { createContext } from "react";

export const SigninContext = createContext(
    {} as {
        success: boolean;
        setSuccess: React.Dispatch<React.SetStateAction<boolean>>;
    }
);
